import { render } from "./ui-tab-profile.vue?vue&type=template&id=35c7e9d4&scoped=true&ts=true"
import script from "./ui-tab-profile.vue?vue&type=script&lang=ts"
export * from "./ui-tab-profile.vue?vue&type=script&lang=ts"

import "./ui-tab-profile.vue?vue&type=style&index=0&id=35c7e9d4&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c7e9d4"]])

export default __exports__